export interface ITotalImpressionsResultAPI {
  accuracy_percentage_off: number;
  avg_erp_seconds_available_per_hour: number;
  cadence_closest: number;
  cadence_impressions_closest: number;
  cadence_impressions_range: number[];
  cadence_range: number[];
  conflicting_lineitems: number[];
  impressions_available: number;
  max_cadence_available: number;
  max_cadence_impressions_available: number;
  max_historical_cadence: number;
  overbooked_reserved_impressions?: number;
  reserved_impressions: number;
  unreserved_impressions: number;
}

export default class TotalImpressionsResult {
  impressionsAvailable: number;

  accuracyPercentageOff: number;

  conflictingLineitems: number[];

  avgErpSecondsAvailablePerHour: number;

  reservedImpressions: number;

  unreservedImpressions: number;

  cadenceRange?: number[];

  cadenceImpressionsRange?: number[];

  maxCadenceAvailable?: number;

  maxCadenceImpressionsAvailable?: number;

  maxHistoricalCadence?: number;

  closestCadenceAvailable?: number;

  closestCadenceImpressionsAvailable?: number;

  overbookedReservedImpressions?: number;

  apiObject?: ITotalImpressionsResultAPI;

  constructor(
    impressionsAvailable: number,
    accuracyPercentageOff: number,
    conflictingLineitems: number[],
    avgErpSecondsAvailablePerHour: number,
    reservedImpressions: number,
    unreservedImpressions: number,
    cadenceRange: number[] | null = null,
    cadenceImpressionsRange: number[] | null = null,
    maxCadenceAvailable?: number,
    maxCadenceImpressionsAvailable?: number,
    maxHistoricalCadence?: number,
    closestCadenceAvailable?: number,
    closestCadenceImpressionsAvailable?: number,
    overbookedReservedImpressions?: number,
  ) {
    this.impressionsAvailable = impressionsAvailable;
    this.accuracyPercentageOff = accuracyPercentageOff;
    this.conflictingLineitems = conflictingLineitems;
    this.avgErpSecondsAvailablePerHour = avgErpSecondsAvailablePerHour;
    this.reservedImpressions = reservedImpressions;
    this.unreservedImpressions = unreservedImpressions;
    this.cadenceRange = cadenceRange;
    this.cadenceImpressionsRange = cadenceImpressionsRange;
    this.maxCadenceAvailable = maxCadenceAvailable;
    this.maxCadenceImpressionsAvailable = maxCadenceImpressionsAvailable;
    this.maxHistoricalCadence = maxHistoricalCadence;
    this.closestCadenceAvailable = closestCadenceAvailable;
    this.closestCadenceImpressionsAvailable = closestCadenceImpressionsAvailable;
    this.overbookedReservedImpressions = overbookedReservedImpressions;
    this.apiObject = null;
  }

  static fromApi(apiObject: ITotalImpressionsResultAPI): TotalImpressionsResult {
    const totalImpressionsResult = new TotalImpressionsResult(
      apiObject.impressions_available,
      apiObject.accuracy_percentage_off,
      apiObject.conflicting_lineitems,
      apiObject.avg_erp_seconds_available_per_hour,
      apiObject.reserved_impressions,
      apiObject.unreserved_impressions,
      apiObject.cadence_range,
      apiObject.cadence_impressions_range,
      apiObject.max_cadence_available,
      apiObject.max_cadence_impressions_available,
      apiObject.max_historical_cadence,
      apiObject.cadence_closest,
      apiObject.cadence_impressions_closest,
      apiObject.overbooked_reserved_impressions,
    );
    totalImpressionsResult.apiObject = apiObject;
    return totalImpressionsResult;
  }
}
